import React from 'react';
import MindfileItemIcon from "../../../pages/explore/items/item-viewer/MindfileItemIcon";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  iconImageList: {
    maxWidth: '100%',
    display:'flex',
    flexWrap:'wrap',
    // justifyContent:'space-evenly',
    gap:'0.125em',
    paddingTop:'1em'
  },
});

function DataIconView(props) {
  const { iconSize, itemList, columnMap, selectedItems, onSelectItem, openDataView,
    moveItems, removeItems, saveItems, folderList, addFolder, mindfileFilterValues,
    mindfileUserLevel, mindfileDisplay, classes } = props;

  return (
      <div id="dataTableIconView" className={classes.iconImageList}>
        {itemList.map((item, index) => (
          <MindfileItemIcon
            key={item.id}
            iconSize={iconSize}
            item={item}
            columnMap={columnMap}
            initialDisplayType="thumbnail"
            isSelected={!!selectedItems[item.id]}
            onSelectItem={() => onSelectItem(item)}
            saveItems={saveItems}
            moveItem={moveItems.bind(this, [item.id])}
            removeItem={removeItems.bind(this, [item.id])}
            folderList={folderList}
            addFolder={addFolder}
            mindfileFilterValues={mindfileFilterValues}
            openDataView={openDataView.bind(this, item.id)}
            mindfileUserLevel={mindfileUserLevel}
            mindfileDisplay={mindfileDisplay}
          />)
        )}
      </div>
    );
}

export default withStyles(styles)(DataIconView);
